/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProfielRouteRouteImport } from './routes/profiel/route'
import { Route as HomeRouteRouteImport } from './routes/home/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StudentOnboardingIndexRouteImport } from './routes/student-onboarding/index'
import { Route as MeldingenIndexRouteImport } from './routes/meldingen/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as HomeIndexRouteImport } from './routes/home/index'
import { Route as CorrespondentieIndexRouteImport } from './routes/correspondentie/index'
import { Route as AgendaIndexRouteImport } from './routes/agenda/index'
import { Route as ProfielPersoonlijke_gegevensRouteImport } from './routes/profiel/persoonlijke_gegevens'
import { Route as ProfielContactpersonenRouteImport } from './routes/profiel/contactpersonen'
import { Route as ProfielBeschikbaarheidRouteImport } from './routes/profiel/beschikbaarheid'
import { Route as OnboardingTokenRouteImport } from './routes/onboarding/$token'
import { Route as MagicLinkSplatRouteImport } from './routes/magic-link/$'
import { Route as LoginTokenRouteImport } from './routes/login/$token'
import { Route as IntakeInplannenRouteImport } from './routes/intake/inplannen'
import { Route as CorrespondentieThreadIdRouteImport } from './routes/correspondentie/$threadId'
import { Route as HomeVoortgangIndexRouteImport } from './routes/home/voortgang/index'
import { Route as HomeRapportagesIndexRouteImport } from './routes/home/rapportages/index'
import { Route as HomeIntakeIndexRouteImport } from './routes/home/intake/index'
import { Route as HomeFacturenIndexRouteImport } from './routes/home/facturen/index'
import { Route as HomeContractenIndexRouteImport } from './routes/home/contracten/index'
import { Route as InvoiceIdUploadIdInvoiceNameFactuurOndertekenenRouteImport } from './routes/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen'
import { Route as DocumentIdContractUploadIdContractNameDocumentOndertekenenRouteImport } from './routes/$documentId/$contractUploadId/$contractName/document-ondertekenen'

const ProfielRouteRoute = ProfielRouteRouteImport.update({
  id: '/profiel',
  path: '/profiel',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRouteRoute = HomeRouteRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentOnboardingIndexRoute = StudentOnboardingIndexRouteImport.update({
  id: '/student-onboarding/',
  path: '/student-onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const MeldingenIndexRoute = MeldingenIndexRouteImport.update({
  id: '/meldingen/',
  path: '/meldingen/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeIndexRoute = HomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HomeRouteRoute,
} as any)
const CorrespondentieIndexRoute = CorrespondentieIndexRouteImport.update({
  id: '/correspondentie/',
  path: '/correspondentie/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgendaIndexRoute = AgendaIndexRouteImport.update({
  id: '/agenda/',
  path: '/agenda/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfielPersoonlijke_gegevensRoute =
  ProfielPersoonlijke_gegevensRouteImport.update({
    id: '/persoonlijke_gegevens',
    path: '/persoonlijke_gegevens',
    getParentRoute: () => ProfielRouteRoute,
  } as any)
const ProfielContactpersonenRoute = ProfielContactpersonenRouteImport.update({
  id: '/contactpersonen',
  path: '/contactpersonen',
  getParentRoute: () => ProfielRouteRoute,
} as any)
const ProfielBeschikbaarheidRoute = ProfielBeschikbaarheidRouteImport.update({
  id: '/beschikbaarheid',
  path: '/beschikbaarheid',
  getParentRoute: () => ProfielRouteRoute,
} as any)
const OnboardingTokenRoute = OnboardingTokenRouteImport.update({
  id: '/onboarding/$token',
  path: '/onboarding/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const MagicLinkSplatRoute = MagicLinkSplatRouteImport.update({
  id: '/magic-link/$',
  path: '/magic-link/$',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginTokenRoute = LoginTokenRouteImport.update({
  id: '/login/$token',
  path: '/login/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const IntakeInplannenRoute = IntakeInplannenRouteImport.update({
  id: '/intake/inplannen',
  path: '/intake/inplannen',
  getParentRoute: () => rootRouteImport,
} as any)
const CorrespondentieThreadIdRoute = CorrespondentieThreadIdRouteImport.update({
  id: '/correspondentie/$threadId',
  path: '/correspondentie/$threadId',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeVoortgangIndexRoute = HomeVoortgangIndexRouteImport.update({
  id: '/voortgang/',
  path: '/voortgang/',
  getParentRoute: () => HomeRouteRoute,
} as any)
const HomeRapportagesIndexRoute = HomeRapportagesIndexRouteImport.update({
  id: '/rapportages/',
  path: '/rapportages/',
  getParentRoute: () => HomeRouteRoute,
} as any)
const HomeIntakeIndexRoute = HomeIntakeIndexRouteImport.update({
  id: '/intake/',
  path: '/intake/',
  getParentRoute: () => HomeRouteRoute,
} as any)
const HomeFacturenIndexRoute = HomeFacturenIndexRouteImport.update({
  id: '/facturen/',
  path: '/facturen/',
  getParentRoute: () => HomeRouteRoute,
} as any)
const HomeContractenIndexRoute = HomeContractenIndexRouteImport.update({
  id: '/contracten/',
  path: '/contracten/',
  getParentRoute: () => HomeRouteRoute,
} as any)
const InvoiceIdUploadIdInvoiceNameFactuurOndertekenenRoute =
  InvoiceIdUploadIdInvoiceNameFactuurOndertekenenRouteImport.update({
    id: '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen',
    path: '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocumentIdContractUploadIdContractNameDocumentOndertekenenRoute =
  DocumentIdContractUploadIdContractNameDocumentOndertekenenRouteImport.update({
    id: '/$documentId/$contractUploadId/$contractName/document-ondertekenen',
    path: '/$documentId/$contractUploadId/$contractName/document-ondertekenen',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/home': typeof HomeRouteRouteWithChildren
  '/profiel': typeof ProfielRouteRouteWithChildren
  '/correspondentie/$threadId': typeof CorrespondentieThreadIdRoute
  '/intake/inplannen': typeof IntakeInplannenRoute
  '/login/$token': typeof LoginTokenRoute
  '/magic-link/$': typeof MagicLinkSplatRoute
  '/onboarding/$token': typeof OnboardingTokenRoute
  '/profiel/beschikbaarheid': typeof ProfielBeschikbaarheidRoute
  '/profiel/contactpersonen': typeof ProfielContactpersonenRoute
  '/profiel/persoonlijke_gegevens': typeof ProfielPersoonlijke_gegevensRoute
  '/agenda/': typeof AgendaIndexRoute
  '/correspondentie/': typeof CorrespondentieIndexRoute
  '/home/': typeof HomeIndexRoute
  '/login/': typeof LoginIndexRoute
  '/meldingen/': typeof MeldingenIndexRoute
  '/student-onboarding/': typeof StudentOnboardingIndexRoute
  '/home/contracten/': typeof HomeContractenIndexRoute
  '/home/facturen/': typeof HomeFacturenIndexRoute
  '/home/intake/': typeof HomeIntakeIndexRoute
  '/home/rapportages/': typeof HomeRapportagesIndexRoute
  '/home/voortgang/': typeof HomeVoortgangIndexRoute
  '/$documentId/$contractUploadId/$contractName/document-ondertekenen': typeof DocumentIdContractUploadIdContractNameDocumentOndertekenenRoute
  '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen': typeof InvoiceIdUploadIdInvoiceNameFactuurOndertekenenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/profiel': typeof ProfielRouteRouteWithChildren
  '/correspondentie/$threadId': typeof CorrespondentieThreadIdRoute
  '/intake/inplannen': typeof IntakeInplannenRoute
  '/login/$token': typeof LoginTokenRoute
  '/magic-link/$': typeof MagicLinkSplatRoute
  '/onboarding/$token': typeof OnboardingTokenRoute
  '/profiel/beschikbaarheid': typeof ProfielBeschikbaarheidRoute
  '/profiel/contactpersonen': typeof ProfielContactpersonenRoute
  '/profiel/persoonlijke_gegevens': typeof ProfielPersoonlijke_gegevensRoute
  '/agenda': typeof AgendaIndexRoute
  '/correspondentie': typeof CorrespondentieIndexRoute
  '/home': typeof HomeIndexRoute
  '/login': typeof LoginIndexRoute
  '/meldingen': typeof MeldingenIndexRoute
  '/student-onboarding': typeof StudentOnboardingIndexRoute
  '/home/contracten': typeof HomeContractenIndexRoute
  '/home/facturen': typeof HomeFacturenIndexRoute
  '/home/intake': typeof HomeIntakeIndexRoute
  '/home/rapportages': typeof HomeRapportagesIndexRoute
  '/home/voortgang': typeof HomeVoortgangIndexRoute
  '/$documentId/$contractUploadId/$contractName/document-ondertekenen': typeof DocumentIdContractUploadIdContractNameDocumentOndertekenenRoute
  '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen': typeof InvoiceIdUploadIdInvoiceNameFactuurOndertekenenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/home': typeof HomeRouteRouteWithChildren
  '/profiel': typeof ProfielRouteRouteWithChildren
  '/correspondentie/$threadId': typeof CorrespondentieThreadIdRoute
  '/intake/inplannen': typeof IntakeInplannenRoute
  '/login/$token': typeof LoginTokenRoute
  '/magic-link/$': typeof MagicLinkSplatRoute
  '/onboarding/$token': typeof OnboardingTokenRoute
  '/profiel/beschikbaarheid': typeof ProfielBeschikbaarheidRoute
  '/profiel/contactpersonen': typeof ProfielContactpersonenRoute
  '/profiel/persoonlijke_gegevens': typeof ProfielPersoonlijke_gegevensRoute
  '/agenda/': typeof AgendaIndexRoute
  '/correspondentie/': typeof CorrespondentieIndexRoute
  '/home/': typeof HomeIndexRoute
  '/login/': typeof LoginIndexRoute
  '/meldingen/': typeof MeldingenIndexRoute
  '/student-onboarding/': typeof StudentOnboardingIndexRoute
  '/home/contracten/': typeof HomeContractenIndexRoute
  '/home/facturen/': typeof HomeFacturenIndexRoute
  '/home/intake/': typeof HomeIntakeIndexRoute
  '/home/rapportages/': typeof HomeRapportagesIndexRoute
  '/home/voortgang/': typeof HomeVoortgangIndexRoute
  '/$documentId/$contractUploadId/$contractName/document-ondertekenen': typeof DocumentIdContractUploadIdContractNameDocumentOndertekenenRoute
  '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen': typeof InvoiceIdUploadIdInvoiceNameFactuurOndertekenenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/home'
    | '/profiel'
    | '/correspondentie/$threadId'
    | '/intake/inplannen'
    | '/login/$token'
    | '/magic-link/$'
    | '/onboarding/$token'
    | '/profiel/beschikbaarheid'
    | '/profiel/contactpersonen'
    | '/profiel/persoonlijke_gegevens'
    | '/agenda/'
    | '/correspondentie/'
    | '/home/'
    | '/login/'
    | '/meldingen/'
    | '/student-onboarding/'
    | '/home/contracten/'
    | '/home/facturen/'
    | '/home/intake/'
    | '/home/rapportages/'
    | '/home/voortgang/'
    | '/$documentId/$contractUploadId/$contractName/document-ondertekenen'
    | '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/profiel'
    | '/correspondentie/$threadId'
    | '/intake/inplannen'
    | '/login/$token'
    | '/magic-link/$'
    | '/onboarding/$token'
    | '/profiel/beschikbaarheid'
    | '/profiel/contactpersonen'
    | '/profiel/persoonlijke_gegevens'
    | '/agenda'
    | '/correspondentie'
    | '/home'
    | '/login'
    | '/meldingen'
    | '/student-onboarding'
    | '/home/contracten'
    | '/home/facturen'
    | '/home/intake'
    | '/home/rapportages'
    | '/home/voortgang'
    | '/$documentId/$contractUploadId/$contractName/document-ondertekenen'
    | '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen'
  id:
    | '__root__'
    | '/'
    | '/home'
    | '/profiel'
    | '/correspondentie/$threadId'
    | '/intake/inplannen'
    | '/login/$token'
    | '/magic-link/$'
    | '/onboarding/$token'
    | '/profiel/beschikbaarheid'
    | '/profiel/contactpersonen'
    | '/profiel/persoonlijke_gegevens'
    | '/agenda/'
    | '/correspondentie/'
    | '/home/'
    | '/login/'
    | '/meldingen/'
    | '/student-onboarding/'
    | '/home/contracten/'
    | '/home/facturen/'
    | '/home/intake/'
    | '/home/rapportages/'
    | '/home/voortgang/'
    | '/$documentId/$contractUploadId/$contractName/document-ondertekenen'
    | '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HomeRouteRoute: typeof HomeRouteRouteWithChildren
  ProfielRouteRoute: typeof ProfielRouteRouteWithChildren
  CorrespondentieThreadIdRoute: typeof CorrespondentieThreadIdRoute
  IntakeInplannenRoute: typeof IntakeInplannenRoute
  LoginTokenRoute: typeof LoginTokenRoute
  MagicLinkSplatRoute: typeof MagicLinkSplatRoute
  OnboardingTokenRoute: typeof OnboardingTokenRoute
  AgendaIndexRoute: typeof AgendaIndexRoute
  CorrespondentieIndexRoute: typeof CorrespondentieIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  MeldingenIndexRoute: typeof MeldingenIndexRoute
  StudentOnboardingIndexRoute: typeof StudentOnboardingIndexRoute
  DocumentIdContractUploadIdContractNameDocumentOndertekenenRoute: typeof DocumentIdContractUploadIdContractNameDocumentOndertekenenRoute
  InvoiceIdUploadIdInvoiceNameFactuurOndertekenenRoute: typeof InvoiceIdUploadIdInvoiceNameFactuurOndertekenenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/profiel': {
      id: '/profiel'
      path: '/profiel'
      fullPath: '/profiel'
      preLoaderRoute: typeof ProfielRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/student-onboarding/': {
      id: '/student-onboarding/'
      path: '/student-onboarding'
      fullPath: '/student-onboarding/'
      preLoaderRoute: typeof StudentOnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meldingen/': {
      id: '/meldingen/'
      path: '/meldingen'
      fullPath: '/meldingen/'
      preLoaderRoute: typeof MeldingenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/': {
      id: '/home/'
      path: '/'
      fullPath: '/home/'
      preLoaderRoute: typeof HomeIndexRouteImport
      parentRoute: typeof HomeRouteRoute
    }
    '/correspondentie/': {
      id: '/correspondentie/'
      path: '/correspondentie'
      fullPath: '/correspondentie/'
      preLoaderRoute: typeof CorrespondentieIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agenda/': {
      id: '/agenda/'
      path: '/agenda'
      fullPath: '/agenda/'
      preLoaderRoute: typeof AgendaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiel/persoonlijke_gegevens': {
      id: '/profiel/persoonlijke_gegevens'
      path: '/persoonlijke_gegevens'
      fullPath: '/profiel/persoonlijke_gegevens'
      preLoaderRoute: typeof ProfielPersoonlijke_gegevensRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/contactpersonen': {
      id: '/profiel/contactpersonen'
      path: '/contactpersonen'
      fullPath: '/profiel/contactpersonen'
      preLoaderRoute: typeof ProfielContactpersonenRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/beschikbaarheid': {
      id: '/profiel/beschikbaarheid'
      path: '/beschikbaarheid'
      fullPath: '/profiel/beschikbaarheid'
      preLoaderRoute: typeof ProfielBeschikbaarheidRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/onboarding/$token': {
      id: '/onboarding/$token'
      path: '/onboarding/$token'
      fullPath: '/onboarding/$token'
      preLoaderRoute: typeof OnboardingTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/magic-link/$': {
      id: '/magic-link/$'
      path: '/magic-link/$'
      fullPath: '/magic-link/$'
      preLoaderRoute: typeof MagicLinkSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/$token': {
      id: '/login/$token'
      path: '/login/$token'
      fullPath: '/login/$token'
      preLoaderRoute: typeof LoginTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intake/inplannen': {
      id: '/intake/inplannen'
      path: '/intake/inplannen'
      fullPath: '/intake/inplannen'
      preLoaderRoute: typeof IntakeInplannenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/correspondentie/$threadId': {
      id: '/correspondentie/$threadId'
      path: '/correspondentie/$threadId'
      fullPath: '/correspondentie/$threadId'
      preLoaderRoute: typeof CorrespondentieThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/voortgang/': {
      id: '/home/voortgang/'
      path: '/voortgang'
      fullPath: '/home/voortgang/'
      preLoaderRoute: typeof HomeVoortgangIndexRouteImport
      parentRoute: typeof HomeRouteRoute
    }
    '/home/rapportages/': {
      id: '/home/rapportages/'
      path: '/rapportages'
      fullPath: '/home/rapportages/'
      preLoaderRoute: typeof HomeRapportagesIndexRouteImport
      parentRoute: typeof HomeRouteRoute
    }
    '/home/intake/': {
      id: '/home/intake/'
      path: '/intake'
      fullPath: '/home/intake/'
      preLoaderRoute: typeof HomeIntakeIndexRouteImport
      parentRoute: typeof HomeRouteRoute
    }
    '/home/facturen/': {
      id: '/home/facturen/'
      path: '/facturen'
      fullPath: '/home/facturen/'
      preLoaderRoute: typeof HomeFacturenIndexRouteImport
      parentRoute: typeof HomeRouteRoute
    }
    '/home/contracten/': {
      id: '/home/contracten/'
      path: '/contracten'
      fullPath: '/home/contracten/'
      preLoaderRoute: typeof HomeContractenIndexRouteImport
      parentRoute: typeof HomeRouteRoute
    }
    '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen': {
      id: '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen'
      path: '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen'
      fullPath: '/$invoiceId/$uploadId/$invoiceName/factuur-ondertekenen'
      preLoaderRoute: typeof InvoiceIdUploadIdInvoiceNameFactuurOndertekenenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$documentId/$contractUploadId/$contractName/document-ondertekenen': {
      id: '/$documentId/$contractUploadId/$contractName/document-ondertekenen'
      path: '/$documentId/$contractUploadId/$contractName/document-ondertekenen'
      fullPath: '/$documentId/$contractUploadId/$contractName/document-ondertekenen'
      preLoaderRoute: typeof DocumentIdContractUploadIdContractNameDocumentOndertekenenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface HomeRouteRouteChildren {
  HomeIndexRoute: typeof HomeIndexRoute
  HomeContractenIndexRoute: typeof HomeContractenIndexRoute
  HomeFacturenIndexRoute: typeof HomeFacturenIndexRoute
  HomeIntakeIndexRoute: typeof HomeIntakeIndexRoute
  HomeRapportagesIndexRoute: typeof HomeRapportagesIndexRoute
  HomeVoortgangIndexRoute: typeof HomeVoortgangIndexRoute
}

const HomeRouteRouteChildren: HomeRouteRouteChildren = {
  HomeIndexRoute: HomeIndexRoute,
  HomeContractenIndexRoute: HomeContractenIndexRoute,
  HomeFacturenIndexRoute: HomeFacturenIndexRoute,
  HomeIntakeIndexRoute: HomeIntakeIndexRoute,
  HomeRapportagesIndexRoute: HomeRapportagesIndexRoute,
  HomeVoortgangIndexRoute: HomeVoortgangIndexRoute,
}

const HomeRouteRouteWithChildren = HomeRouteRoute._addFileChildren(
  HomeRouteRouteChildren,
)

interface ProfielRouteRouteChildren {
  ProfielBeschikbaarheidRoute: typeof ProfielBeschikbaarheidRoute
  ProfielContactpersonenRoute: typeof ProfielContactpersonenRoute
  ProfielPersoonlijke_gegevensRoute: typeof ProfielPersoonlijke_gegevensRoute
}

const ProfielRouteRouteChildren: ProfielRouteRouteChildren = {
  ProfielBeschikbaarheidRoute: ProfielBeschikbaarheidRoute,
  ProfielContactpersonenRoute: ProfielContactpersonenRoute,
  ProfielPersoonlijke_gegevensRoute: ProfielPersoonlijke_gegevensRoute,
}

const ProfielRouteRouteWithChildren = ProfielRouteRoute._addFileChildren(
  ProfielRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HomeRouteRoute: HomeRouteRouteWithChildren,
  ProfielRouteRoute: ProfielRouteRouteWithChildren,
  CorrespondentieThreadIdRoute: CorrespondentieThreadIdRoute,
  IntakeInplannenRoute: IntakeInplannenRoute,
  LoginTokenRoute: LoginTokenRoute,
  MagicLinkSplatRoute: MagicLinkSplatRoute,
  OnboardingTokenRoute: OnboardingTokenRoute,
  AgendaIndexRoute: AgendaIndexRoute,
  CorrespondentieIndexRoute: CorrespondentieIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  MeldingenIndexRoute: MeldingenIndexRoute,
  StudentOnboardingIndexRoute: StudentOnboardingIndexRoute,
  DocumentIdContractUploadIdContractNameDocumentOndertekenenRoute:
    DocumentIdContractUploadIdContractNameDocumentOndertekenenRoute,
  InvoiceIdUploadIdInvoiceNameFactuurOndertekenenRoute:
    InvoiceIdUploadIdInvoiceNameFactuurOndertekenenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
